module.exports = __webpack_public_path__ + "static/media/tourist_arrival_ph_map_worldwide_wide.30a53db7.png";